import { CompoundEntityRef } from '@backstage/catalog-model';
import { createApiRef } from '@backstage/core-plugin-api';

/**
 * Where one environment's definition came from. `version` is the pipeline's
 * S3 object metadata and is absent when it did not set it.
 */
export interface PublishInfo {
  name: string;
  /** ISO 8601. */
  lastModified?: string;
  size?: number;
  version?: string;
}

export interface ApiEnvironments {
  /** In display order. Empty when nothing has published yet. */
  environments: PublishInfo[];
  /** The environment to open on; absent when `environments` is empty. */
  defaultEnvironment?: string;
}

export interface ApiEnvironmentDefinition {
  environment: PublishInfo;
  definition: string;
}

export interface ApiDocsEnvironmentsApi {
  getEnvironments(api: CompoundEntityRef): Promise<ApiEnvironments>;
  getDefinition(
    api: CompoundEntityRef,
    environment: string,
  ): Promise<ApiEnvironmentDefinition>;
}

export const apiDocsEnvironmentsApiRef = createApiRef<ApiDocsEnvironmentsApi>({
  id: 'plugin.api-docs-environments.api',
});
